export const ServiceMark = ({ color = '#FFB800', className }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true" focusable="false">
    <circle cx="24" cy="24" r="24" fill={color} />
    <rect x="13" y="11" width="9" height="26" rx="4.5" fill="#ffffff" transform="rotate(28 17.5 24)" />
    <circle cx="31" cy="30" r="5.5" fill="#ffffff" />
  </svg>
);

export const SlashMark = ({ className, bar = '#0B1729', dot = '#FFB800' }) => (
  <svg viewBox="0 0 96 96" className={className} aria-hidden="true" focusable="false">
    <rect x="14" y="8" width="26" height="80" rx="13" fill={bar} transform="rotate(28 27 48)" />
    <circle cx="66" cy="62" r="16" fill={dot} />
  </svg>
);
